export default __webpack_public_path__ + "static/media/speaker2.eb16f48b.jpg";